<template>
    <div>
      <el-dialog :title="$t('componentMsg.012')" :show-close="false" :visible.sync="planDialogVisible"  width="30%" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="planData" :rules="planRules" ref="planRef" label-width="120px">
            <el-form-item :label="$t('componentMsg.013')" prop="name">
                <el-input v-model="planData.name"  maxlength="30"
                show-word-limit></el-input>
            </el-form-item>
            <el-form-item :label="$t('componentMsg.014')" prop="type">
                <el-select v-model="planData.type" disabled style="width:100%">
                <el-option :label="$t('componentMsg.015')" :value="1"></el-option>
                <el-option :label="$t('componentMsg.016')" :value="4"></el-option>
                <el-option :label="$t('componentMsg.017')" :value="5"></el-option>
                </el-select>
            </el-form-item>
        </el-form>        
        <span slot="footer" class="dialog-footer">
        <el-button  @click="cancelPlan">{{$t("message.systemMsg.Cancel")}}</el-button>
        <el-button type="primary" @click="savePlan">{{$t("message.systemMsg.Submit")}}</el-button>
      </span>
      </el-dialog>
    </div>
  </template>
  <script>
import {addConfiguration,updateConfiguration} from "@/api/stage";
  export default {
    data() {
      return {
        planDialogVisible: false,
        planData:{
            name:"",
            type:this.planType,
        },
        planRules:{
            name: [
            { required: true, message: this.$t('componentMsg.018'), trigger: 'blur' },
            ],
        }
      };
  },
  props: {
    showPlanDialog: {
      type: Boolean,
      default:false
    },
    planType:{
        type:Number
    },
    fatherPlanData:{
        type:Object
    },
    fatherPlanNoHandleData:{
      type:Object
    },
    savePlanId:{
      type:String
    },
    saveName:{
      type:String
    }
  },
  watch: {
    showPlanDialog(newVal) {
      this.planDialogVisible = newVal;
    },
  },
  methods:{
     // 保存
     savePlan(){
        if(this.savePlanId&&this.savePlanId!=''){
          // 调用修改接口
          const data={
            configuration:{
                name:this.planData.name,
                type:this.planType,
                content:JSON.stringify(this.fatherPlanData),
                front:JSON.stringify(this.fatherPlanNoHandleData),
                id:this.savePlanId
            }
          }
          this.$refs['planRef'].validate((valid) => {
            if (valid) {
              updateConfiguration(data).then(res=>{
                if(res.success){
                  this.$message.success(this.$t('componentMsg.019'));
                      this.$emit('handleClosePlanDialog',false);
                      this.$router.push("/SaveConfigScheme");
                }else{
                  this.$message.error(this.$t(`code.${res.errorCode}`)+res.errorInfo?res.errorInfo:'');
                }
              }).catch(error=>{
                console.log(error);
                
                this.$message.error(this.$t(`code.${error.errorCode}`)+error.errorInfo?error.errorInfo:'');
              })
            }})
        }else{
          const data={
            configuration:{
                name:this.planData.name,
                type:this.planType,
                content:JSON.stringify(this.fatherPlanData),
                front:JSON.stringify(this.fatherPlanNoHandleData)
            }
        }
          this.$refs['planRef'].validate((valid) => {
            if (valid) {
              addConfiguration(data).then(res=>{
                console.log(res);
                
                  if(res.success){
                      this.$message.success(this.$t('componentMsg.019'));
                      this.$emit('handleClosePlanDialog',false);
                      this.planData={
                          name:"",
                          type:this.planType,
                      };
                      this.$router.push("/SaveConfigScheme");
                  }else{
                this.$message.error(this.$t(`code.${res.errorCode}`)+res.errorInfo?res.errorInfo:'');
                  }
              }).catch(error=>{
                this.$message.error(error.message);
              })
            }})
        }
    },
    cancelPlan(){
        this.$emit('handleClosePlanDialog',false);
        this.$refs['planRef'].resetFields();
        this.planData={
            name:"",
            type:this.planType,
        }
    }
  },
  created(){
    if(this.saveName){
      this.planData.name=this.saveName;
    }
  }
}
  </script>